module.exports = __webpack_public_path__ + "static/media/goal.svg.bae3ce9b.png";